/* ═══════════════ ATYR STUDIO — SEEN ON (lookbook) ═══════════════
   Each card holds its tagged products in a <template>; opening a card
   clones them into the shared modal. No fetching, no duplicated markup.

   Closing behaves the way shoppers expect:
     · browser / Android Back closes the modal and stays on Seen On
       (the modal pushes a history entry while it's open)
     · clicking any empty/blurred area closes it — only links and the
       photo itself are treated as "content" and left alone
     · Esc and the × also close                                        */
(function () {
  'use strict';

  function init() {
    var modal = document.getElementById('so-modal');
    if (!modal) return;

    var imgEl     = document.getElementById('so-modal-img');
    var handleEl  = document.getElementById('so-modal-handle');
    var captionEl = document.getElementById('so-modal-caption');
    var listEl    = document.getElementById('so-modal-list');
    var labelEl   = document.getElementById('so-modal-label');
    var lastFocus = null;
    var pushed    = false;   // did WE add the history entry that's currently on top?

    function open(card) {
      var media = card.querySelector('.so-card__media img');
      var tpl   = card.querySelector('[data-so-products]');

      if (media) {
        /* reuse the already-downloaded grid image first so the modal paints
           instantly, then swap to the full-size source */
        imgEl.src = media.currentSrc || media.src;
        imgEl.alt = media.alt || '';
        var full = card.getAttribute('data-full');
        if (full && full !== imgEl.src) {
          var hi = new Image();
          hi.onload = function () { imgEl.src = full; };
          hi.src = full;
        }
      }

      var handle = card.getAttribute('data-handle') || '';
      var url    = card.getAttribute('data-handle-url') || '';
      if (handle) {
        if (url) {
          handleEl.innerHTML = '<a target="_blank" rel="noopener"></a>';
          handleEl.firstChild.href = url;
          handleEl.firstChild.textContent = handle;
        } else {
          handleEl.textContent = handle;
        }
      }
      handleEl.hidden = !handle;

      var caption = card.getAttribute('data-caption') || '';
      captionEl.textContent = caption;
      captionEl.hidden = !caption;

      listEl.innerHTML = '';
      var hasProducts = false;
      if (tpl && tpl.content) {
        listEl.appendChild(tpl.content.cloneNode(true));
        hasProducts = !!listEl.querySelector('.so-prod');
      }
      labelEl.hidden = !hasProducts;
      if (window.atyrPriceFix) window.atyrPriceFix(listEl);  /* currency/decimals before paint */

      lastFocus = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      /* Back should dismiss the modal, not leave the page */
      if (!pushed) {
        try { history.pushState({ soModal: true }, ''); pushed = true; } catch (e) {}
      }

      var closeBtn = modal.querySelector('[data-so-close]');
      if (closeBtn) closeBtn.focus();
    }

    /* fromPopstate: the browser already moved us back, so don't move again */
    function close(fromPopstate) {
      if (!modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();

      if (pushed) {
        pushed = false;
        if (!fromPopstate) { try { history.back(); } catch (e) {} }
      }
    }

    document.addEventListener('click', function (e) {
      /* open */
      var trigger = e.target.closest('[data-so-open]');
      if (trigger) {
        var card = trigger.closest('[data-so-card]');
        if (card) { e.preventDefault(); open(card); }
        return;
      }

      if (!modal.classList.contains('is-open')) return;
      if (!e.target.closest('#so-modal')) return;

      /* explicit close button */
      if (e.target.closest('[data-so-close]')) { e.preventDefault(); close(); return; }

      /* leave real content alone: links navigate, the photo is not a dismiss target */
      if (e.target.closest('a')) return;
      if (e.target === imgEl) return;

      /* everything else inside the modal — the blurred gaps around and between
         the products, the empty panel space — dismisses it */
      close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    window.addEventListener('popstate', function () {
      /* Back pressed while open → just close, stay on the Seen On page */
      close(true);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
